import React from "react";

export default function SchemaOptimizerIconButton({
	title,
	iconClass,
	onClick,
	disabled,
	danger,
	accent,
}) {
	return (
		<button
			type="button"
			className={`schema-optimizer__icon-btn${
				danger ? " schema-optimizer__icon-btn--danger" : ""
			}${accent ? " schema-optimizer__icon-btn--accent" : ""}`}
			title={title}
			aria-label={title}
			disabled={disabled}
			onClick={onClick}
		>
			<i className={iconClass} aria-hidden />
		</button>
	);
}
